import { Component, OnInit, ViewChild } from '@angular/core';
import { PoPageDefault, PoBreadcrumb, PoBreadcrumbItem, PoTableColumn, PoTableSubtitleColumn, PoSelectOption, PoNotificationService } from '@po-ui/ng-components';
import * as ngComponents from '@po-ui/ng-components';
import { UtilService } from 'src/app/services/util-service/util.service';
import { DicionarioService } from 'src/app/services/dicionario/dicionario.service';
import { BrowserService } from 'src/app/services/browser/browser.service';
import { Router } from '@angular/router';
import { LegendaService } from 'src/app/services/legenda/legenda.service';
import { SessionService } from 'src/app/services/session/session.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UploadService } from 'src/app/services/upload/upload.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cotacao-aberto-list',
  templateUrl: './cotacao-aberto-list.component.html',
  styleUrls: ['./cotacao-aberto-list.component.css']
})
export class CotacaoAbertoListComponent implements OnInit {

  uploadURL = `${environment.protheus}/upload`;

  @ViewChild('anexoModal', { static: true }) anexoModal: ngComponents.PoModalComponent;

  public page: PoPageDefault = {
    title: 'Cotações em Aberto',
    breadcrumb: {
      items: [
        { label: 'Home' },
        { label: 'Cotações em Aberto' },
      ] as PoBreadcrumbItem[]
    } as PoBreadcrumb,
    actions: [
      {
        label: 'Alterar', icon: 'po-icon-edit', separator: true, action: () => {
          if (this.isSelected()) {
            this.router.navigate(['cotacao/em-aberto/edit', this.cotacaoSelecionada.REGISTRO]);
          }
        }
      },
      {
        label: 'Visualizar', icon: 'po-icon-view', separator: true, action: () => {
          if (this.isSelected()) {
            this.router.navigate(['cotacao/em-aberto/view', this.cotacaoSelecionada.REGISTRO]);
          }
        }
      },
      {
        label: 'Anexar Documento', icon: 'po-icon-file', separator: true, action: () => {
          if (this.isSelected()) {
            this.retornaFiles();
            setTimeout(() => {
              this.anexoModal.open();
            }, 1000);
          }
        }
      }
    ]
  };

  public tableColumns: Array<PoTableColumn> = [];
  public tableItems = [];
  public tableHeight = 0;
  private cotacaoSelecionada: any;
  public loading = true;
  private legenda: Array<PoTableSubtitleColumn> = [];
  public arrFields: any[];
  public options = {};
  public fieldsModal: PoTableColumn[];
  public informacoes: any;

  selects = {
    cores: [] as Array<PoSelectOption>
  };

  public pagination = {
    itemsPerPage: 50,
    totalItems: 0,
    currentPage: 1
  };

  constructor(
    private utilService: UtilService,
    private notificationService: PoNotificationService,
    private dicionarioService: DicionarioService,
    private browserService: BrowserService,
    private router: Router,
    private legendaService: LegendaService,
    private sessionService: SessionService,
    private uploadService: UploadService
  ) { }

  public tableConhecimentoColumns: Array<any> = [];
  public tableConhecimentoItems = [];
  public mostrarArquivos = false;
  public labelButton = 'Exibir Arquivos';
  public allItens = false;
  public item: any[] = [];

  public retornaFiles() {
    this.loading = true;
    this.uploadService.listFiles('SF8', this.cotacaoSelecionada.REGISTRO)
      .subscribe((data: any) => {
        this.tableConhecimentoColumns = [
          { property: 'descricao', label: 'Nome Arquivo', width: '80%' },
        ];
        this.tableConhecimentoColumns.push({
          label: 'Ações', property: 'actions', width: '20%', type: 'icon', icons: [
            { label: 'Baixar', icon: 'po-icon po-icon-download', action: this.fakeDownload.bind(this), value: 'baixar' },
            // { label: 'Remover', icon: 'po-icon-delete', action: this.fakeRemove.bind(this), value: 'remover' }
          ]
        });
        this.tableConhecimentoItems = data.arquivos;
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        console.error(err);
        this.notificationService.error('Não foi possível recuperar os arquivos desta Nota Fiscal, por favor tente novamente');
      });
  }

  unAllSelectedItem(event: any) {
    this.allItens = false;
    this.item = [];
    console.log(this.item);
  }

  public selectedItem(event) {
    this.allItens = false;
    this.item.push(event);
    console.log(this.item);
  }

  public unSelectedItem(event) {
    if (this.item[0].length > 0) {
      this.item = this.item[0].filter(item => item.recno !== event.recno);
    } else {
      this.item = this.item.filter(item => item.recno !== event.recno);
    }
    console.log(this.item);

  }

  allSelectedItem(event: any) {
    this.allItens = true;
    this.item.push(event);
    console.log(this.item);

  }

  exibeFiles() {
    this.mostrarArquivos = !this.mostrarArquivos;
    if (this.mostrarArquivos === true) {
      this.labelButton = 'Ocultar Arquivos';
    } else {
      this.labelButton = 'Exibir Arquivos';
    }
  }

  downloadFiles() {
    console.log(this.item);
    const arr = this.item.map((ret) => {
      return ret.recno.toString();
    });
    // const arr = arrTeste.join(';');
    this.uploadService.downloadFile(arr)
      .subscribe((data: any) => {
        const blob = new Blob([data], );
        const url = window.URL.createObjectURL(blob);
        console.log(blob);
        const el = document.createElement('a');
        el.href = url;
        el.download = `${Date.now()}.zip`;
        document.body.append(el);
        el.click();
        this.notificationService.success('Arquivo baixado com sucesso!');
      });
  }

  public anexaArquivo(event) {
    return this.uploadService.uploadHandler(event, {
      arquivo: event.file.name,
      extensao: event.file.extension,
      aliasTabela: 'SF8',
      registro: this.cotacaoSelecionada.REGISTRO,
    });
  }

  fakeDownload(item) {
    this.uploadService.downloadFile(item.recno)
      .subscribe((data: any) => {
        const blob = new Blob([data], );
        const url = window.URL.createObjectURL(blob);
        console.log(blob);
        const el = document.createElement('a');
        el.href = url;
        el.download = item.descricao;
        document.body.append(el);
        el.click();
        this.notificationService.success('Arquivo baixado com sucesso!');
      });
  }

  ngOnInit(): void {
    this.sessionService.info$
      .subscribe((data) => {
        this.informacoes = data;
      });

    this.getLegenda('cota', 'SC8');
  }

  public selected(event) {
    this.cotacaoSelecionada = event;
  }

  public unSelected(event) {
    this.cotacaoSelecionada = {};
  }

  private isSelected() {
    if (this.cotacaoSelecionada === {} || this.cotacaoSelecionada === undefined) {
      this.notificationService.warning('Selecione uma cotação !');
      return false;
    } else {
      // this.notificationService.warning('Não é possível realizar essa solicitação!');
      return true;
    }
  }

  private getDicionario() {
    this.loading = true;
    const param = {
      // codigo: this.codigoAcesso
      tabela: 'SC8'
    };
    this.dicionarioService
      .fsbDicionario(this.utilService.getParameters(param))
      .subscribe((data: any) => {
        let auxiliarColumns: Array<any> = data.dados[0].dynamicView[0].fields;

        auxiliarColumns = auxiliarColumns.filter(item => item.browse === true);

        auxiliarColumns.sort((a, b) => {
          if (a.sequence < b.sequence) {
            return -1;
          } else if (a.sequence > b.sequence) {
            return 1;
          } else {
            return 0;
          }
        });

        this.arrFields = [];
        this.tableColumns = auxiliarColumns.map((item) => {
          if (item.option.length > 0) {
            this.options[item.property] = [];
            const arr: Array<string> = item.option.split(';');
            this.options[item.property] = arr.map((value) => {
              const d = value.split('=');
              return { value: d[0], label: d[1] } as PoSelectOption;
            });
          }

          let pixels: number = parseInt(item.width, 10) * 25;
          if (pixels <= 125) {
            pixels = 125;
          } else if (pixels > 200) {
            pixels = 200;
          } else {
            pixels = parseInt(item.width, 10) * 25;
          }

          let obj: PoTableColumn = {};

          let typeTable = '';
          let formatTable = '';

          if (item.TIPO === 'D') {
            typeTable = 'date';
            formatTable = 'dd/MM/yyyy';
          } else if (item.TIPO === 'N') {
            obj.type = 'number';
          }

          obj = { label: item.label, property: item.property, width: `${pixels}px`, type: `${typeTable}`, format: `${formatTable}` };

          return obj;
        });

        this.tableHeight = this.utilService.calcularHeight(innerHeight, 0.45);
        this.tableColumns.unshift({ label: '-', property: 'COR', width: '50px', type: 'subtitle', subtitles: this.legenda });


        this.getCotacao();

        // this.loading = false;
      },
        (error: HttpErrorResponse) => {
          this.notificationService.error('Error ao carregar os dados!');
          console.log(error.error);
          this.loading = false;
        });
  }

  private getCotacao(tabela?: string) {
    this.tableItems = [];
    const obj = {
      pagina: this.pagination.currentPage,
      itenspagina: this.pagination.itemsPerPage,
      tabela: 'SC8',
      rotina: 'cota',
      cnpj: this.informacoes.FORNECEDOR[0].A2_CGC
    };
    this.browserService
      .fsbBrowser(this.utilService.getParameters(obj))
      .subscribe((ret: any) => {

        this.tableItems = Object.values(ret);
        this.tableItems = this.tableItems[0];

        this.tableItems.map((item) => {
          Object.keys(this.options).map((data) => {
            if (data in item) {
              const options = this.options[data].find(element => element.value === item[data]);
              item[data] = options === undefined ? '' : options.label;
            }
          });

        });
        this.loading = false;
        this.pagination.totalItems = ret.total;
      },
        (error) => {
          this.notificationService.error(`Erro ao carregar os dados : ${error.errorMessage}`);
          console.log(error.error);
          this.loading = false;
        });
  }

  private getLegenda(rotina: string, tabela: string) {
    this.loading = true;
    this.legendaService
      .getLegenda(rotina, tabela)
      .subscribe((data) => {
        this.legenda = data.dados.map((item) => {
          this.selects.cores.push({ label: item.descricao, value: item.status });
          return { label: item.descricao, value: item.cor, color: item.cor, content: '' } as PoTableSubtitleColumn;
        });

        this.getDicionario();
      },
        (error: HttpErrorResponse) => {
          this.loading = false;
        });
  }

  public onPageChange(event: number) {
    this.pagination.currentPage = event;
    this.getCotacao();
  }

}
